import React from "react";
import { email, required } from "../../../helpers/form-validation";
import { Row, Col, FormLabel } from "react-bootstrap";
import Input from "react-validation/build/input";
import Form from "react-validation/build/form";
import "./quote-form.scss";

const REQUIRED_VALIDATIONS = [required];
const EMAIL_VALIDATIONS = [required, email];
const OPTIONAL_VALIDATIONS = [];
const END_USER_FIELDS = [
    { name: "firstName", label: "First name", optional: true },
    { name: "lastName", label: "Last name", optional: true },
    { name: "emailAddress", label: "Email address", validations: EMAIL_VALIDATIONS },
    { name: "companyName", label: "Company", optional: true },
    { name: "phoneNumber", label: "Phone number", optional: true, type: "tel" },
    { name: "BillingAddress1", label: "Address line 1", validations: REQUIRED_VALIDATIONS },
    { name: "BillingAddress2", label: "Address line 2", optional: true },
    { name: "City", label: "City", validations: REQUIRED_VALIDATIONS },
    { name: "State", label: "State / province", validations: REQUIRED_VALIDATIONS },
    { name: "PostalCode", label: "Postal code", validations: REQUIRED_VALIDATIONS },
    { name: "Country", label: "Country", validations: REQUIRED_VALIDATIONS },
];

export const CreateEndUser = React.forwardRef(({ handleChange }, ref) => {
    return (
        <Form ref={ref}>
            <Row>
                {END_USER_FIELDS.map((field) => (
                    <Col md="6" className="mb-3" key={field.name}>
                        <FormLabel htmlFor={`end-user-${field.name}`}>
                            {field.label} {field.validations && <span aria-hidden="true">*</span>}
                            {field.optional && <span className="field-optional">Optional</span>}
                        </FormLabel>
                        <Input
                            id={`end-user-${field.name}`}
                            className="input form-control custom-input"
                            type={field.type || "text"}
                            name={field.name}
                            validations={field.validations || OPTIONAL_VALIDATIONS}
                            onChange={handleChange}
                            placeholder={field.label}
                        />
                    </Col>
                ))}
            </Row>
        </Form>
    );
});